module.exports = __webpack_public_path__ + "media/images/blue_logo-b9b926d18106a574abb996c2c78f215d.png";